<template>
   <v-container fluid fill-height class="loginOverlay">
    <v-layout flex align-center justify-center>
      <v-flex xs12 md6 lg4 elevation-6>
        <v-toolbar class="pa-4 tool-bar-app darken-1">
          <v-layout justify-center align-center style="height: 100%;">
            <img class="login--logo" src="@/assets/imagens/logo_mono_cp.png" alt="Logo siged">
          </v-layout>
        </v-toolbar>
        <v-card>
          <form @submit.prevent="confirmar">
            <v-card-text class="pt-4">
                <span style="font-size: 20px!important">
                  {{username}}
                </span>
                <br>

                <Select v-if="this.optionsAno.length > 0" label="Ano" :options="optionsAno" v-model.number="ano" class="escolhar-escola-ano" @change="mudarAno"/>

                <span class="subheading" v-if="filtroSchool.length > 0">Escolha uma Escola</span>
                <transition name="choose-school-anim" enter-active-class="animated fadeIn">
                  <v-radio-group class="w-100" v-model="escola_escolhida">
                    <v-radio class="rd" ref="focar" v-for="school in filtroSchool"  :key="school.cdescola" :value="school">
                      <div slot="label" > {{school.nmescola}} </div>
                    </v-radio>

                        <v-alert type="error" :value="filtroSchool.length === 0" transition="scale-transition" >
                        É importante que se tenha autorização para acessar o diário e possuir vínculo com a escola e turmas. Favor procurar a secretaria escolar.
                      </v-alert>


                  </v-radio-group>

                </transition>
            </v-card-text>
            <v-card-text>
              <v-btn type="submit" :loading="loading" :disabled="escola_escolhida === null" class="accent white--text rounded-sm font-weight-regular">
                Entrar
              </v-btn>
            </v-card-text>
          </form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';
import api from '../../api';


export default {
  name: 'EscolherEscola',
  data(){
    return {
      escola_escolhida: null,
      ano: null,
      loading: false,
    };
  },
  async beforeRouteEnter (to, from, next) {
    if (store.getters.schools > 0 && typeof this.schools[0].anos === 'undefined') {
      store.dispatch('alterarEscola', store.getters.schools[0]);
      return next('/');
    }
    next();
  },
  created() {
    this.ano = this.getAnoAtualServidor;
    if(this.filtroSchool.length > 0) {
      this.escola_escolhida = this.filtroSchool[0];
      if(this.filtroSchool.length === 1) { this.confirmar(); }
    }
  },
  mounted() {
    if(this.filtroSchool > 0) {
      this.$refs.focar[0].$el.children[0].children[0].focus();
    }
  },
  methods: {
    mudarAno() {
      this.escola_escolhida = null;
    },
    confirmar(){
      this.loading = true;
      this.alterarEscola(this.escola_escolhida);
      this.inserirAno(this.ano);
      setTimeout(() => { this.$router.push('/'); }, 1000);
    },
    ...mapActions(['alterarEscola', 'inserirAno'])
  },
  computed: {
    ...mapGetters(['profile', 'username', 'schools', 'getAnoAtualServidor', 'getAnoInicioSistema']),
    filtroSchool() {
      if(this.schools.length <= 0) { return []; }
      if(typeof this.schools[0].anos === 'undefined') { return this.schools; }

      const result = (this.ano) ? this.schools.filter(key => key.anos.indexOf(this.ano) >= 0)
                                : this.schools;
      return result
    },
    optionsAno() {
      if(!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }
      let retornoOptions = [];
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
  },
}
</script>

<style lang="scss" scoped>
.escolhar-escola-ano {
  width: 100%;
  margin-top: 20px;
}

.loginOverlay {
  background-image: url("~@/assets/login-bg.png");
  background-repeat: repeat;
}

.login--logo {
  height: 100%;
}

.w-100{
  width: 100%;
}

.rd{
  border: 1px solid rgba(0, 0, 0, 0.2);
  width: 100%;
  padding: 10px;
  border-radius: 3px;
}
</style>
